import { render, staticRenderFns } from "./PayBoxItemsList.vue?vue&type=template&id=6af8f39d&scoped=true&"
import script from "./PayBoxItemsList.vue?vue&type=script&lang=js&"
export * from "./PayBoxItemsList.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxItemsList.vue?vue&type=style&index=0&id=6af8f39d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af8f39d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6af8f39d')) {
      api.createRecord('6af8f39d', component.options)
    } else {
      api.reload('6af8f39d', component.options)
    }
    module.hot.accept("./PayBoxItemsList.vue?vue&type=template&id=6af8f39d&scoped=true&", function () {
      api.rerender('6af8f39d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/PayBoxItemsList.vue"
export default component.exports